import styled, { css } from 'styled-components';
import { layout } from 'src/styles/layout';
import { palette } from 'src/styles/colors';

export interface StyledCTAContainerProps {
  paddingTop?: string;
  rowGap?: string;
  theme?: string;
}

const proThemeCss = css`
  padding-top: 40px;
  padding-bottom: 40px;

  @media screen and (min-width: ${layout.subLg}) {
    padding-top: 80px;
  }

  a {
    min-width: 256px;
  }
`;

const proThemeTitleCss = css`
  background: linear-gradient(-5deg, ${palette.proBlue} 12.4%, #ffdf6e 111.55%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  max-width: 620px;
`;

export const CallToActionContainer = styled.div<StyledCTAContainerProps>`
  display: grid;
  position: relative;
  padding-top: ${({ paddingTop }) => paddingTop || '8em'};
  padding-right: 2em;
  padding-left: 2em;
  padding-bottom: 5em;
  row-gap: ${({ rowGap }) => rowGap || '3.475em'} ;

  ${({ theme }) => theme === 'pro' ? proThemeCss : ''}

  & > h1 {
    max-width: 937px;
    justify-self: center;

    ${({ theme }) => theme === 'pro' ? proThemeTitleCss : ''}
  }

  & > p {
    max-width: 540px;
    justify-self: center;
  }
`;
